import { createContext } from 'react'
import { State, Actions } from '../state'
import { AsyncDispatch } from '@sales-center/common'

type TCallTrackingContext = [
  state: State,
  dispatch: AsyncDispatch<Actions | Promise<Actions>>,
]

export const CallTrackingContext = createContext<
  TCallTrackingContext | undefined
>(undefined)
